(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('whitelabelEditorService', whitelabelEditorService);

  function whitelabelEditorService(
    _
  ) {
    'ngInject';

    const components = ['General', 'Header', 'Sidebar', 'Widget Panel', 'External Pages', 'Open Registration', 'Reset Password'];

    const brandLogoCSSVariable = '--brand-logo';
    const brandFaviconCSSVariable = '--brand-favicon';
    const brandNameCSSVariable = '--brand-name';
    let defaultFaviconValue = '/images/favicons/favicon.ico';
    const loginWelcomeMessageCSSVariable = '--component-login__welcome-message';

    const componentsProperties = {
      'General': {
        properties: [{
          name: 'Background',
          variablesToChange: ['--reset-body-bg-color'],
          defaultValue: ''
        },
        {
          name: 'Font Color',
          variablesToChange: ['--reset-body-font-color'],
          defaultValue: ''
        },
        {
          name: 'Link Font Color',
          variablesToChange: ['--component-link-font-color', '--component-link--hover-font-color'],
          defaultValue: ''
        }]
      },
      'Header': {
        properties: [{
          name: 'Background',
          variablesToChange: ['--component-site-header-bg'],
          defaultValue: ''
        },
        {
          name: 'Link Font Color',
          variablesToChange: ['--component-site-header-link-font-color'],
          defaultValue: ''
        },
        {
          name: 'Live Call Counter Color',
          variablesToChange: ['--component-site-header__call-counter--live'],
          defaultValue: ''
        },
        {
          name: 'Completed Call Counter Color',
          variablesToChange: ['--component-site-header__call-counter--completed'],
          defaultValue: ''
        }]
      },
      'Sidebar': {
        properties: [{
          name: 'Background',
          variablesToChange: ['--component-sidebar__menu-bg', '--component-sidebar__sub-menu-line'],
          defaultValue: ''
        },
        {
          name: 'Menu Highlight Background',
          variablesToChange: ['--component-sidebar__menu--highlight'],
          defaultValue: ''
        },
        {
          name: 'Menu Font Color',
          variablesToChange: ['--component-sidebar__menu-font-color'],
          defaultValue: ''
        },
        {
          name: 'Submenu Background',
          variablesToChange: ['--component-sidebar__submenu-bg'],
          defaultValue: ''
        },
        {
          name: 'Submenu Font Color',
          variablesToChange: ['--component-sidebar__submenu-font-color'],
          defaultValue: ''
        },
        {
          name: 'Submenu Highlighted Font Color',
          variablesToChange: ['--component-sidebar__submenu-active-font-color'],
          defaultValue: ''
        }]
      },
      'Widget Panel': {
        properties: [{
          name: 'Background',
          variablesToChange: ['--component-widget-panel__holder-bg'],
          defaultValue: ''
        },
        {
          name: 'Header Background',
          variablesToChange: ['--component-widget-panel__header-bg'],
          defaultValue: ''
        },
        {
          name: 'Header Title Color',
          variablesToChange: ['--component-widget-panel__title-font-color'],
          defaultValue: ''
        }]
      },
      'External Pages': {
        properties: [
          {
            name: 'Background',
            variablesToChange: ['--component-login__left-part-bg'],
            defaultValue: ''
          },
          {
            name: 'Header Background',
            variablesToChange: ['--component-login__header-bg'],
            defaultValue: ''
          },
          {
            name: 'Login Title',
            variablesToChange: ['--component-login__welcome-message'],
            defaultValue: '',
            isTextInput: true
          },
          {
            name: 'Login Sub Title',
            variablesToChange: ['--component-login__welcome-sub-message'],
            defaultValue: '',
            isTextInput: true
          },
          {
            name: 'Join Invite Title',
            variablesToChange: ['--component-join-invite__welcome-message'],
            defaultValue: '',
            isTextInput: true
          },
          {
            name: 'Title Color',
            variablesToChange: ['--component-login__welcome-message-font-color', '--component-login__links-font-color'],
            defaultValue: ''
          },
          {
            name: 'Generic Font Color',
            variablesToChange: ['--component-login__font-color'],
            defaultValue: ''
          }],
        previewLinkState: [{
          state: 'login'
        },
        {
          state: 'join-invite',
          params: {
            'inviteId': 'testInvite',
            'fname': 'Test User'
          }
        },
        {
          state: 'forgot-password'
        }]
      },
      'Open Registration': {
        properties: [
          {
            name: 'Publisher Registration Page Title',
            variablesToChange: ['--component-publisher-registration__welcome-message'],
            defaultValue: '',
            isTextInput: true
          },
          {
            name: 'Buyer Registration Page Title',
            variablesToChange: ['--component-buyer-registration__welcome-message'],
            defaultValue: '',
            isTextInput: true
          },
          {
            name: 'Background',
            variablesToChange: ['--component-publisher-registration__center-bg'],
            defaultValue: ''
          },
          {
            name: 'Title Color',
            variablesToChange: ['--component-publisher-registration__welcome-message-font-color'],
            defaultValue: ''
          },
          {
            name: 'Open Registration Font Color',
            variablesToChange: ['--component-publisher-registration__font-color'],
            defaultValue: ''
          }],
        previewLinkState: [{
          name: 'Publisher Registration',
          state: 'prp-register',
          params: {
            'prpId': 'testPrp'
          }
        }, {
          name: 'Buyer Registration',
          state: 'brp-register',
          params: {
            'brpId': 'testBrp'
          }
        }]
      },
      'Reset Password': {
        properties: [{
          name: 'Form Background',
          variablesToChange: ['--component-auth-container-bg'],
          defaultValue: ''
        }],
        previewLinkState: [{
          state: 'pw',
          name: 'Reset Password'
        }]
      }
    };

    const service = {
      getBrandLogoCssVariable: getBrandLogoCssVariable,
      getBrandFaviconCssVariable: getBrandFaviconCssVariable,
      getBrandNameCssVariable: getBrandNameCssVariable,
      getComponentsList: getComponentsList,
      getComponentPropertiesList: getComponentPropertiesList,
      setDefaultComponentPropertyValuesOnBootstrap: setDefaultComponentPropertyValuesOnBootstrap,
      getCSSVariableValue: getCSSVariableValue,
      checkDefaultCSSVarValue: checkDefaultCSSVarValue,
      setLogoBase64ToTheme: setLogoBase64ToTheme,
      getLogoBase64FromTheme: getLogoBase64FromTheme,
      setFaviconBase64ToTheme: setFaviconBase64ToTheme,
      getFaviconBase64FromTheme: getFaviconBase64FromTheme,
      getLoginWelcomeMessageFromTheme: getLoginWelcomeMessageFromTheme,
      setLoginWelcomeMessageFromTheme: setLoginWelcomeMessageFromTheme,
      checkThemeIsLight: checkThemeIsLight,
      getComponentPreviewState: getComponentPreviewState,
      getBrandFaviconDefaultValue: getBrandFaviconDefaultValue
    };

    return service;

    function getBrandLogoCssVariable() {
      return brandLogoCSSVariable;
    }

    function getBrandFaviconCssVariable() {
      return brandFaviconCSSVariable;
    }

    function getBrandNameCssVariable() {
      return brandNameCSSVariable;
    }

    function getBrandFaviconDefaultValue() {
      return defaultFaviconValue;
    }

    function getComponentsList() {
      return angular.copy(components);
    }

    function getComponentPropertiesList() {
      return angular.copy(componentsProperties);
    }

    function setDefaultComponentPropertyValuesOnBootstrap() {
      _.forEach(componentsProperties, function(component) {
        _.forEach(component.properties, function(property) {
          _.forEach(property.variablesToChange, function(cssVar) {
            property.defaultValue = getComputedStyle(document.documentElement, null).getPropertyValue(cssVar);
            return false;
          });
        });
      });
      // Set default favicon variable
      defaultFaviconValue = getCSSVariableValue(brandFaviconCSSVariable);
      defaultFaviconValue = defaultFaviconValue ? defaultFaviconValue.trim().replace(/"/g, '') : '';
    }

    function getCSSVariableValue(cssVar) {
      return getComputedStyle($('body')[0], null).getPropertyValue(cssVar);
    }

    function checkDefaultCSSVarValue(componentName, propertyName) {
      try {
        return _.find(componentsProperties[componentName].properties, {name: propertyName}).defaultValue.trim().toUpperCase().replace('#', '');
      } catch {
        return '';
      }
    }

    function setLogoBase64ToTheme(defaultTheme, base64Logo) {
      return _setThemeProperty(defaultTheme, brandLogoCSSVariable, base64Logo);
    }

    function getLogoBase64FromTheme(theme) {
      return _getThemeProperty(theme, brandLogoCSSVariable);
    }

    function setFaviconBase64ToTheme(defaultTheme, base64Favicon) {
      return _setThemeProperty(defaultTheme, brandFaviconCSSVariable, base64Favicon);
    }

    function getFaviconBase64FromTheme(theme) {
      return _getThemeProperty(theme, brandFaviconCSSVariable) || defaultFaviconValue;
    }

    function setLoginWelcomeMessageFromTheme(defaultTheme, message) {
      return _setThemeProperty(defaultTheme, loginWelcomeMessageCSSVariable, message);
    }

    function getLoginWelcomeMessageFromTheme(theme) {
      return _getThemeProperty(theme, loginWelcomeMessageCSSVariable);
    }

    function checkThemeIsLight(theme) {
      return theme && theme.isLightTheme;
    }

    function getComponentPreviewState(componentName) {
      return componentsProperties[componentName].previewLinkState;
    }

    function _setThemeProperty(theme, propertyName, value) {
      theme = theme ? angular.copy(theme) : { default: {} };
      if (value) {
        theme.default[propertyName] = value;
      } else {
        delete theme.default[propertyName];
      }
      return theme;
    }

    function _getThemeProperty(theme, propertyName) {
      if (theme && theme.default) {
        return theme.default[propertyName] || null;
      }
      return null;
    }
  }
})();
